import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/passengers/admin`,
});

// ✅ Get all passengers
export async function getAllPassengersByAdmin() {
  try {
    const res = await API.get("/get-all-passengers", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Post passengers with payload (pagination + search)
export async function postPassengersByAdmin(payload) {
  try {
    const res = await API.post("/post-all-passengers", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Update passenger status/status
export async function updatePassengerStatusByAdmin(passengerId, payload) {
  try {
    const res = await API.put(
      `/${passengerId}/status`,
      payload, // 👈 backend expects { status: "Blocked" } or { payload: {...} }
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Update passenger status/details
export async function updatePassengerDetailsByAdmin(passengerId, payload) {
  try {
    const res = await API.put(
      `/${passengerId}/details`,
      payload, // 👈 backend expects { status: "Blocked" } or { payload: {...} }
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
